import React from 'react'

// css
import 'assets/style/elements/icon-button.scss'

function Element({
  inText = false, // 텍스트 보임 유무
  text = '',
  size = '24',
  className = '',
  type,
  style = {},
  border = false,
  color = '',
  bg = 'none',
  onClick = () => {},
  badgeCnt = 0,
  textStyle = {},
}) {
  if (color !== '') className += ' btn-icon-' + color
  if ([true, 'true'].includes(border)) {
    className += ' bordered'
  }
  className += ' size-' + size
  className += ' bg-' + bg

  // if (color != '') type += '-' + color

  return (
    <>
      <button
        type="button"
        style={style}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          onClick(type)
        }}
        className={`btn-icon ${type} ${inText !== false ? 'in-text' : ''} ` + className}
      >
        <span className="alttxt" style={textStyle}>
          {text}
        </span>
        {badgeCnt > 0 && <span className="badge-count">{badgeCnt}</span>}
      </button>
    </>
  )
}

export default Element
